import { GDPRCookieAction, GDPRCookieActionKeys } from './actions';

export interface GDPRCookieState {
	isDisplayed: boolean;
}

const initialState: GDPRCookieState = {
	isDisplayed: false,
};

export function GDPRCookie(state: GDPRCookieState = initialState, action: GDPRCookieAction): GDPRCookieState {
	switch (action.type) {
		case GDPRCookieActionKeys.SET_IS_DISPLAYED:
			return {
				...state,
				isDisplayed: action.isDisplayed,
			};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CookieNotification/GDPRCookie/reducer.ts